import { createModel } from "hox";
import { useState, useEffect } from "react";
import { IRepairTemplateDetail, IRepairTemplateSearch } from "./repairTemplateType";
import { DEFAULT_FIRST_PAGE_NUM, DEFAULT_PAGE_SIZE, } from "@/utils/constants";
import { TablePaginationConfig } from "antd/es/table/interface";
import { transPgToPagination, formatNum, bigNumber } from "@/utils/utils";
import { ISearchPage } from "@/types/ScmTypes";
import { repairTemplateService } from "./repairTemplateService";
import { message } from "antd";
import { sourceAppOrBranch } from "@/types/VrmSaDictEnums";
import useGlobalModel from "@/model/globalModel";
import { convertRes2Blob } from "@/utils/exportFile";
export interface IDescTotal {
    num: number
    totalAmount: number
    receivableTotalAmount: number
}
export interface IPrint {
    visible: boolean,
    type: number,
}
export const useRepairTemplateModel = createModel(function () {
    const { shopAndOrg, setLoadingInfo } = useGlobalModel(({ shopAndOrg }) => [shopAndOrg]);
    const [print, setPrint] = useState<boolean>(false);
    const [loading, setLoading] = useState<boolean>(false)
    const initDesc = {
        num: 0,
        totalAmount: 0,
        receivableTotalAmount: 0
    }
    const initSearchParam: IRepairTemplateSearch = {};
    const initDataSource: IRepairTemplateDetail[] = [];
    const initPgCfg: TablePaginationConfig = { pageSize: DEFAULT_PAGE_SIZE, current: DEFAULT_FIRST_PAGE_NUM }
    //查询条件
    const [searchParam, setSearchParam] = useState<IRepairTemplateSearch>(initSearchParam);
    //列表数据源
    const [dataSource, setDataSource] = useState<IRepairTemplateDetail[]>(initDataSource);
    //表格选中行Key值
    const [selectedRowKeys, setSelectedRowKeys] = useState<string[]>([]);
    //表格选中的值
    const [selectedRow, setSelectedRow] = useState<IRepairTemplateDetail>({});
    const [descTotal, setDescTotal] = useState<IDescTotal>(initDesc);
    //选中的数据统计展示的数据
    const [rowsDescTotal, setRowsDescTotal] = useState<IDescTotal>(initDesc);
    const [descRows, setDescRows] = useState<IRepairTemplateDetail[]>([]);
    //列表数据源分页参数
    const [pgCfg, setPgCfg] = useState<TablePaginationConfig>(initPgCfg);

    useEffect(() => {
        setSearchParam(initSearchParam);
        setSelectedRowKeys([])
    }, [shopAndOrg.shopCode])
    useEffect(() => {
        let newRowsDescTotal = initDesc
        descRows.forEach((item, index) => {
            let { totalAmount, receivableTotalAmount } = item
            newRowsDescTotal.num += +1
            // newRowsDescTotal.totalAmount += +formatNum(totalAmount)
            // newRowsDescTotal.receivableTotalAmount += +formatNum(receivableTotalAmount)
            newRowsDescTotal.totalAmount = bigNumber.add(newRowsDescTotal.totalAmount, totalAmount as number | string)
            newRowsDescTotal.receivableTotalAmount = bigNumber.add(newRowsDescTotal.receivableTotalAmount, receivableTotalAmount as number | string)
            console.log(totalAmount, receivableTotalAmount)
            console.log(newRowsDescTotal)
        })
        setRowsDescTotal(newRowsDescTotal)
    }, [descRows])
    useEffect(() => {
        let filters = dataSource.filter(el => selectedRowKeys.length > 0 ? el.id === selectedRowKeys[0] : false);
        const selectedData = filters && filters.length > 0 ? filters[0] : undefined;
        setSelectedRow(selectedData as IRepairTemplateDetail)
    }, [selectedRowKeys, dataSource])

    const updateSearchParam = (updateParam: IRepairTemplateSearch) => {
        setSearchParam({ ...searchParam, ...updateParam })
    }
    const resetSearchParam = () => {
        setSearchParam(initSearchParam);
        loadData(initPgCfg, {});
        setSelectedRowKeys([])
    }
    const reset = () => {
        setSearchParam(initSearchParam);
        loadData(initPgCfg, {});
        setSelectedRowKeys([])
    }
    const loadData = async (page?: ISearchPage, searchValue: IRepairTemplateSearch = searchParam) => {
        setLoading(true);
        const shopParam = {
            shopType: searchValue.shopId !== undefined ? 1 : shopAndOrg.shopType,
            shopId: searchValue.shopId ?? shopAndOrg.shopId
        };
        const searchParams = {
            ...searchValue,
            ...shopParam,
            ...sourceAppOrBranch,
            pageSize: page?.pageSize ?? pgCfg.pageSize ?? DEFAULT_PAGE_SIZE,
            pageNum: (page?.pageNum || page?.current) ?? pgCfg.current ?? DEFAULT_FIRST_PAGE_NUM,
        }
        let { retData } = await repairTemplateService.page(searchParams);
        setLoading(false);
        const { records, ...pg } = retData;
        setPgCfg(transPgToPagination(pg));
        setDataSource(records);
        // let { retData: statistics } = await repairTemplateService.total(searchParams);
        // setDescTotal(statistics)

    }
    const exportRepairTemplateRo = async (searchValue: IRepairTemplateSearch = searchParam) => {
        setLoadingInfo({ loadingVisible: true, txt: "快速导出中" })
        const searchParams = {
            ...searchValue,
            ...shopAndOrg,
            // id: selectedRowKeys.join(),
        }
        try {
            let result = await repairTemplateService.export(searchParams);
            result && setLoadingInfo({ loadingVisible: false, txt: "" });
            convertRes2Blob(result)
        } catch {
            setLoadingInfo({ loadingVisible: false, txt: "" });
        }

    }
    //下载模板
    const downloadTpl = async () => {
        let result = await repairTemplateService.downloadTpl();
        convertRes2Blob(result);
    }
    const [scaniaPrint, setScaniaPrint] = useState<IPrint>({ visible: false, type: 1 });
    const [settleScaniaPrint, setSettleScaniaPrint] = useState<boolean>(false);

    return {
        searchParam,
        dataSource,
        selectedRowKeys,
        selectedRow,
        pgCfg,
        initPgCfg,
        setSearchParam,
        setDataSource,
        setSelectedRowKeys,
        setSelectedRow,
        setPgCfg,
        updateSearchParam,
        resetSearchParam,
        loadData,
        print, setPrint,
        descTotal, setDescTotal,
        exportRepairTemplateRo,
        loading, setLoading,
        scaniaPrint, setScaniaPrint,
        settleScaniaPrint, setSettleScaniaPrint,
        rowsDescTotal, setRowsDescTotal,
        descRows, setDescRows,
        reset, downloadTpl
    }
})